import FormularioResponderEditar from './FormularioResponderEditar';

export default FormularioResponderEditar;